import { render, staticRenderFns } from "./EditSignature.vue?vue&type=template&id=13c59249&"
import script from "./EditSignature.vue?vue&type=script&lang=js&"
export * from "./EditSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports